import type { GetAppResponse } from '@wix/ambassador-devcenter-apps-v1-app/types';
import { DocumentServicesObject } from '@wix/document-services-types';
import { appMarketService } from '../utils/appMarketService';

const APP_DEF_ID_QUERY = 'flowAppDefId';
const APP_PARAMS_QUERY = 'flowAppParams';

function getParameterByName(name: string) {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(name);
  return paramValue;
}

const getEditorScriptUrl = (appInfo: GetAppResponse): string | undefined => {
  const components = appInfo?.data?.components;
  if (components && Array.isArray(components)) {
    const compData = components.find((comp) => comp?.compType === 'PLATFORM');
    return (
      compData?.compData?.platformComponentData?.editorScriptUrl ?? undefined
    );
  }
  return undefined;
};

const parseFlowAppParams = (flowAppParamsJSON: string): object => {
  let flowAppParams = {};
  try {
    flowAppParams = JSON.parse(flowAppParamsJSON);
  } catch (originalError) {
    try {
      // support also url-encoded json param
      flowAppParams = JSON.parse(decodeURIComponent(flowAppParamsJSON));
    } catch (e) {
      console.error(
        'Failed to parse flowAppParams. expected a JSON format.',
        originalError,
      );
    }
  }
  return flowAppParams;
};

function runFlowPlatformApps(documentServices: DocumentServicesObject) {
  const flowAppDefId = getParameterByName(APP_DEF_ID_QUERY);

  if (!flowAppDefId) {
    return;
  }

  const flowAppParamsJSON = getParameterByName(APP_PARAMS_QUERY);

  let flowAppParams = {};
  if (flowAppParamsJSON) {
    flowAppParams = parseFlowAppParams(flowAppParamsJSON);
  }

  appMarketService.fetchAppInfo(flowAppDefId).then((appInfo) => {
    if (!appInfo) {
      return;
    }

    const editorScriptUrl = getEditorScriptUrl(appInfo);

    if (!editorScriptUrl) {
      return;
    }

    documentServices.platform.initApp(
      {
        appDefinitionId: flowAppDefId,
        appFields: {
          platform: {
            baseUrls: {},
            editorScriptUrl,
          },
        },
      },
      flowAppParams,
    );
  });
}

export { runFlowPlatformApps };
